import React from "react";
import ListView from "../listviews/ListView";
import TextField2 from "../textfields/TextField2";
import SecondaryButton from "../buttons/SecondaryButton";
import Row from "../layout/Row";
import Space from "../layout/Space";
import Divider from "../layout/Divider";
import DropDown1 from "../dropdowns/DropDown1";
import DropDownGPT1 from "../dropdowns/DropDownGPT1";
import Modal1 from "../modals/Modal1";
import { useState } from "react";
import { useSnackbar } from "notistack";
import createNewMember from "../api/create/createNewMember";
import sendInvite from "../api/send/sendInvite";
import {
  getArrayDocDataByID,
  getArrayDocDataByRef,
  getDocDataById,
  queryCollection,
} from "../models/DataFunctions";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken";
import SmallSpinner from "../loading/SmallSpinner";
import TextField2T from "../textfields/TextField2T";
import DropDownGPTS3 from "../dropdowns/DropDownGPTS3";
import DropDownGPT03 from "../dropdowns/DropDownGTP03";
import { memberRoles } from "./MemberManager";
import { getOrgById } from "../models/OrgFunctions";

function MembresClient({
  orgData,
  title,
  users,
  removable,
  none_text = "Aucun membre",
  prefix,
  handleRefresh,
  setMemberOpen,
  masterData,
  disabled = false,
}) {
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  const [membres_open, setMembresOpen] = useState(false);
  const [email_value, setEmailValue] = useState("");
  const [role, setRole] = useState(null);
  const [org_admin, setOrgAdmin] = useState(false);
  const [display_name, setDisplayName] = useState("");
  const [loadingDaa, setLoadingData] = useState(false);

  const handleAddMember = async () => {
    setLoadingData(true);
    const email = email_value;
    // check email is valid format
    if (!email.includes("@") || !email.includes(".")) {
      handleClickVariant("Email invalide", "error");

      setLoadingData(false);
      return;
    }
    if (role == null || role === "") {
      handleClickVariant(
        "Veuillez sélectionner un type d'utilisateur",
        "error"
      );
      setLoadingData(false);
      return;
    }

    const filters = [
      {
        field: "email",
        operator: "==",
        value: email,
      },
    ];
    const doublons = await queryCollection("user", filters);
    if (doublons.length > 0) {
      handleClickVariant("Cet email est déjà utilisé", "error");
      setLoadingData(false);
      return;
    }

    try {
      const token = await getOrRefreshFirebaseToken();
      await createNewMember(
        orgData.id,
        email.trim(),
        display_name,
        role,
        org_admin,
        token,
        prefix
      ); // Call the sendInvite API
      handleClickVariant("Membre ajouté avec succès", "success");

      const org = await getOrgById(orgData.id);
      let users = (await getArrayDocDataByID("user", org.users_id || [])) || [];
      let new_user = users.find((user) => user.email === email);
      await sendInvite(
        new_user.id,
        org.name,
        new_user.email,
        org.id,
        token,
        prefix
      ); // Call the sendInvite API
      handleClickVariant("Invitation envoyée avec succès", "success");
      setEmailValue("");
      setDisplayName("");
      setRole("");
      setMembresOpen(false);
      setLoadingData(false);
      handleRefresh();
    } catch (error) {
      handleClickVariant("Erreur lors de l'envoi de l'invitation", "error");
      setLoadingData(false);
      console.error(error);
    }
  };

  return (
    <div className="w-full">
      <Modal1 isOpen={membres_open} onClose={() => setMembresOpen(false)}>
        {" "}
        <div className="flex flex-col gap-1 w-c400  bg-white rounded-xl p-4">
          <TextField2T
            label="Email"
            type="email"
            mandatory={true}
            value={email_value}
            onChange={(e) => setEmailValue(e.target.value)}
          ></TextField2T>
          <TextField2T
            label="Prénom Nom"
            mandatory={true}
            value={display_name}
            onChange={(e) => setDisplayName(e.target.value)}
          ></TextField2T>
          <DropDownGPT03
            mandatory={true}
            label="Type d'utilisateur"
            value={role}
            onChange={(e) => {
              setRole(e.value);
            }}
            sx={{ width: "495px" }}
            items={memberRoles}
          />

          <Space x={0} />
          <div className="flex flex-row justify-end">
            <SecondaryButton
              className="w-fit"
              disabled={email_value === "" || role === null}
              onClick={handleAddMember}
            >
              Inviter{" "}
              {loadingDaa && <SmallSpinner loading={true}></SmallSpinner>}
            </SecondaryButton>
          </div>
        </div>
      </Modal1>
      <div className="text-h1 font-semibold text-pr ">{title}</div>
      <Space y={10} />

      <Space y={10} />
      <div className="w-full  ">
        <ListView
          users={users}
          removable={removable}
          setMemberOpen={setMemberOpen}
          canopen={true}
          disabled={disabled}
        ></ListView>
        {users.length === 0 && (
          <>
            <div className="flex flex-row gap-3 bg-neutral-200  rounded-xl px-2 py-1 w-fit">
              <div className="text-h3 font-semibold text-shadow_50">
                {none_text}
              </div>
            </div>
          </>
        )}{" "}
        <Space y={10} />
        <div className="w-full flex flex-row justify-end">
          <SecondaryButton
            disabled={disabled}
            onClick={() => setMembresOpen(true)}
          >
            Ajouter un membre
          </SecondaryButton>
        </div>
      </div>
    </div>
  );
}

export default MembresClient;
